import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from "axios";
import i18next from "i18next";
import getAPIbaseURL from "../../utils/helpers";

const API_URL = `${getAPIbaseURL()}/work-time-registers`;

export const fetchWorkTimeSuggestions = createAsyncThunk(
  'workTimeRegister/fetchSuggestions',
  async (_, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_URL}/suggestions`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data || i18next.t("slices.workTimeRegister.error_fetch_suggestions")
      );
    }
  }
);

export const submitWorkTimeRegisters = createAsyncThunk(
  'workTimeRegister/submitRegisters',
  async (registersList, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      
      const promises = registersList.map(register => {

        return axios.post(
          `${API_URL}/`,
          register, 
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      });

      await Promise.all(promises);

      return true;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data || i18next.t("slices.workTimeRegister.error_submit_registers")
      );
    }
  }
);

const initialState = {
  isModalOpen: false,
  loading: false,     
  submitting: false,  
  checkoutCoords: null, 
  suggestions: { 
    total_worked_hours_today: 0, 
    projects: [], 
    activity_types: [] 
  },
  error: null,
};

const workTimeRegisterSlice = createSlice({
  name: 'workTimeRegister',
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.isModalOpen = true;
      state.checkoutCoords = action.payload; 
    },
    closeWorkTimeRegisterModal: (state) => {
      state.isModalOpen = false;
      state.checkoutCoords = null;
      state.error = null;
      state.suggestions = initialState.suggestions;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkTimeSuggestions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWorkTimeSuggestions.fulfilled, (state, action) => {
        state.loading = false;
        state.suggestions = action.payload; 
      })
      .addCase(fetchWorkTimeSuggestions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(submitWorkTimeRegisters.pending, (state) => {
        state.submitting = true;
        state.error = null;
      })
      .addCase(submitWorkTimeRegisters.fulfilled, (state) => {
        state.submitting = false;
      })
      .addCase(submitWorkTimeRegisters.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.payload;
      });
  },
});

export const { openModal, closeWorkTimeRegisterModal } = workTimeRegisterSlice.actions;

export default workTimeRegisterSlice.reducer;